import { InfoOutlined } from '@mui/icons-material';
import { Checkbox, FormControlLabel, IconButton, Tooltip, Typography } from '@mui/material';

interface FeatureSettingCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  id: string;
  label: string;
  tooltip?: string;
  onChange: (checked: boolean) => void;
}

const FeatureSettingCheckbox = ({
  checked,
  disabled = false,
  id,
  label,
  tooltip,
  onChange,
}: FeatureSettingCheckboxProps) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={checked}
        disabled={disabled}
        id={id}
        name={id}
        onChange={event => onChange(event.target.checked)}
      />
    }
    label={
      <Typography component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        {label}
        {tooltip && (
          <Tooltip title={tooltip} describeChild>
            <IconButton
              aria-label={`More information about ${label}`}
              size="small"
              sx={{ p: 0.25 }}>
              <InfoOutlined fontSize="inherit" />
            </IconButton>
          </Tooltip>
        )}
      </Typography>
    }
  />
);

export default FeatureSettingCheckbox;
